import React from "react";
import * as Icons from "@/assets/features/requistion";
import EmptyImg from '@/assets/images/Empty.png'
const EmptyScreening = ({title,description,type}) => {
  return (
    <div className="flex flex-col justify-center items-center gap-[0.75rem] mt-15">
      <img src={type=="qtn"?Icons.EmptyScreen:EmptyImg} alt="Empty Screening" className={`h-30 ${type=="qtn"?"w-40":"w-30"}`} />
      <h1 className="capitalize text-lg font-semibold">
        {title}
      </h1>
      <p className="capitalize text-sm ">{description}</p>
    </div>
  );
};

export default EmptyScreening;
